import angular from 'angular';
import setCreditCheckModal from './setCreditCheckModal';
import './style.scss';

export default angular
  .module('components.setCreditCheckModal', [])
  .component('setCreditCheckModal', setCreditCheckModal).name;
